module.exports = __webpack_public_path__ + "img/aq.b95845a.svg";